// extracted by mini-css-extract-plugin
export default {"button":"MenuButton_button__R2bdP"};